"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExpireTime = exports.cacheMinutes = exports.baseConfig = void 0;
exports.getExternalUrl = getExternalUrl;
exports.postExternalUrl = postExternalUrl;
var _axios = require("@ori/axios");
/* istanbul ignore file -- api */

const baseConfig = exports.baseConfig = {
  apiDomain: '//photorankapi-a.akamaihd.net/',
  apiVersion: 'v2.2',
  isIncludeTaggedGalleries: true,
  isRightsGiven: true,
  wrapResponses: 0 // 1|0 1 => do not return 404 error message directly, 0 => standard 404 response (https://help.photorank.me/en/articles/5971266-olapic-widget-api-version-2-2)
};
const cacheMinutes = exports.cacheMinutes = {
  categories: 120,
  info: 120,
  media: 20,
  streams: 120
};
const getExpireTime = minutes => {
  const sec = 60;
  const milisec = 1000;
  const expireHours = minutes * sec * milisec;
  return Date.now() - expireHours;
};
exports.getExpireTime = getExpireTime;
async function getExternalUrl(url, options) {
  const {
    ...config
  } = options;
  const headers = {
    ...config.headers
  };
  const response = await _axios.axios.get(`${url}`, {
    ...config,
    headers
  });
  return response;
}
async function postExternalUrl(url, options) {
  const {
    ...config
  } = options;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- need to use unsafe assignment
  const postData = {
    ...config.data
  };
  const response = await _axios.axios.post(`${url}`, {
    ...postData
  }, {
    ...config
  });
  return response;
}
